import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ThemeMode = "light" | "dark";

const initialState = {
  mode: "dark" as ThemeMode, // Default theme
};

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    }
  },
});

export const { toggleTheme } = themeSlice.actions;
export default themeSlice.reducer;
